import React from 'react';
import { ThemeProvider } from 'styled-components';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Dot } from '../../../../../../CommonComponents/OPL/Dot/Dot';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { formatCurrency } from '../../../../../../CommonUtils/formatNumber';
import { theme } from '../../../../../../theme/theme';

interface Props {
  points: {
    series: {
      name: string;
    };
    color: string;
    y: number;
  }[];
}

export const Tooltip: React.FC<Props> = ({ points }) => (
  <ThemeProvider theme={theme}>
    <Box minWidth="160px" px="8" py="4">
      <Text color="gray.100" fontSize="small" fontWeight={600}>
        Projected Balance
      </Text>
      {points.map(({ y, color, series: { name } }) => (
        <Box display="flex" alignItems="center" mt="4" justifyContent="space-between" key={name}>
          <Box display="flex">
            <Dot bg={color} mr="4" />
            <Text fontSize="small" color="gray.100">
              {name}
            </Text>
          </Box>
          <Text fontSize="small" color="bg" fontWeight={600} ml="2">
            {formatCurrency(y)}
          </Text>
        </Box>
      ))}
    </Box>
  </ThemeProvider>
);
